






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'GFullWidthTemplate',
})
export default class GFullWidthTemplate extends Vue {}
